import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'gpe-close',
  templateUrl: './close.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CloseComponent { }
